import { useParams } from "react-router-dom";
import styles from "./styles.module.scss";
import { useEffect, useMemo, useState } from "react";
import listService from "api/listService";
import { IPackage } from "dto/IPackage";
import PDFViewer from "components/PDFViewer";
import Comments from "components/Comments";
import useGetPDFViewer from "hooks/useGetPDFViewer";
import { ItemKind } from "dto/IKindItems";

const PDFModule = () => {
  const {
    kind,
    packageId,
    threadId,
    PDFId,
    threadPackageId,
  } = useParams();
  const [showPDF, setShowPDF] = useState<Blob | string | null>(null);

  const { data: packageData } = listService.useGetPackage({
    FilterId: packageId ?? "",
    Kind: kind ? Number(kind) : ItemKind.None,
    enabled: true,
  });

  useGetPDFViewer();

  const documentID = `${
    threadPackageId ?? packageId ?? threadId
  }:${kind}:${PDFId}`;

  const previewPackage: IPackage = useMemo(
    () => (packageData?.data?.Items?.[0] as IPackage) ?? [],
    [packageData],
  );


  const [showVersion] = useState(false);


  useEffect(() => {
    // if (!!previewPackage) {
    //   if (previewPackage.Kind === ItemKind.CaseFile) {
    //     console.log('1');
    //     getFileAndDecrypt(previewPackage.S3 ?? '', previewPackage.Kind);
    //     return;
    //   }
    //   const attach = previewPackage?.Attachments?.find(
    //     (attachment) => attachment.Id === packageId || attachment.Id === PDFId
    //   );

    //   if (!attach) return;
    //   console.log('2');
    //   onPreview(attach);
    // }

    const pdf = sessionStorage.getItem("pdf");

    if (!pdf) return;

    const retrievedUint8Array = new Uint8Array(JSON.parse(pdf!));
    const blob = new Blob([retrievedUint8Array], {
      type: "application/octet-stream",
    });
    setShowPDF(blob);
  }, [previewPackage]);

  return (
    <div className={styles.wrapper}>
      {showVersion && (
        <PDFViewer file={new Blob([])} showVersion={showVersion} />
      )}
      {showPDF && <PDFViewer isRightSide file={showPDF} />}

      <div className={styles.commentsWrapper}>
        <Comments documentID={documentID} />
      </div>
    </div>
  );
};

export default PDFModule;
